import { faBuilding, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';

type Props = {
  supplierId?: number | null;
  supplierName?: string | null;
  compact?: boolean;
};

const SupplierName = ({
  supplierId,
  supplierName,
  compact = false
}: Props) => {
  const name = supplierName?.trim() || 'Pending supplier';
  const canOpen = Boolean(supplierId);

  const openIcon = canOpen ? (
    <OverlayTrigger
      overlay={<Tooltip id={`open-supplier-${supplierId}`}>Open supplier</Tooltip>}
    >
      <Link
        to={`/supplier-details/${supplierId}`}
        className="text-body-tertiary"
        aria-label={`Open ${name}`}
      >
        <FontAwesomeIcon icon={faExternalLinkAlt} style={{ fontSize: '0.7rem' }} />
      </Link>
    </OverlayTrigger>
  ) : null;

  if (compact) {
    return (
      <span className="d-inline-flex align-items-center gap-1">
        <span>{name}</span>
        {openIcon}
      </span>
    );
  }

  return (
    <div className="d-flex align-items-center gap-2 p-3 rounded-3 border border-translucent bg-body-highlight">
      <div
        className="d-flex align-items-center justify-content-center rounded-circle bg-primary-subtle flex-shrink-0"
        style={{ width: '1.5rem', height: '1.5rem' }}
      >
        <FontAwesomeIcon icon={faBuilding} className="text-primary" style={{ fontSize: '0.7rem' }} />
      </div>
      <div className="min-w-0 flex-grow-1">
        <div className="fs-10 text-body-tertiary text-uppercase">Supplier</div>
        <div className="d-inline-flex align-items-center gap-1">
          <span className="fw-semibold text-truncate">{name}</span>
          {openIcon}
        </div>
      </div>
    </div>
  );
};

export default SupplierName;
